<template>
  <div class="user_container">
    <div class="carManageContainer">
      <div class="tabsContainer">
        <van-tabs v-model="active" @click="tabClick" color="#4EA27C" line-height="4px" line-width="20px">
          <van-tab name="车辆预定" title="车辆预定">
            <predetermine ref="predetermine" v-if="active == '车辆预定'" />
          </van-tab>
          <van-tab name="我的申请" title="我的申请">
            <Applyfor ref="Applyfor" v-if="active == '我的申请'" />
          </van-tab>
        </van-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import Applyfor from "../Applyfor/Applyfor.vue";
import predetermine from "../predetermine/predetermine";
export default {
  name: "carManage",
  props: {},
  components: {
    Applyfor,
    predetermine
  },
  data() {
    return {
      active: "车辆预定",
    };
  },
  created() {
  },
  mounted() { },
  methods: {
    // tab切换
    tabClick() {
      if (this.active === '车辆预定' && this.$refs.predetermine !== undefined) {
        this.$refs.predetermine.page = 1;
        this.$refs.predetermine.onLoad();
      } else if (this.active === '我的申请' && this.$refs.Applyfor !== undefined) {
        console.log(1111111);
        this.$refs.Applyfor.page = 1;
        this.$refs.Applyfor.onLoad();
      }
    }
  },
  // 重新调用子组件的onLoad方法
  // 解决tab切换时，子组件不重新加载的问题
  activated() {
    sessionStorage.removeItem('addressInfoList');
    sessionStorage.removeItem('carInfo');
    if (this.active === '车辆预定' && this.$refs.predetermine !== undefined) {
      this.$refs.predetermine.page = 1;
      this.$refs.predetermine.onLoad();
    } else if (this.active === '我的申请' && this.$refs.Applyfor !== undefined) {
      this.$refs.Applyfor.page = 1;
      this.$refs.Applyfor.onLoad();
    }
  },
  watch: {
    // 监听路由变化，重新加载数据
    $route(to, from) {
      console.log(to);
      console.log(from);
      if (to.path == '/car/index' || to.path == "/car/facility/index") {
        this.active = '车辆预定';
      }
    }
  },
  deactived() {
    console.log('销毁');
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  .user_container {
    width: 100%;
  }
}

@media screen and (min-width: 600px) {
  .user_container {
    width: 276px * $zoom;
  }
}

@media screen and (min-width: 600px) {
  ::v-deep(.van-popup--top) {
    left: 50%;
    width: 680px;
    margin-left: -340px;
  }
}

.user_container {
  width: 100%;
  display: flex;
  justify-content: center;

  .carManageContainer {
    width: 100%;
    max-width: 780px;

    .tabsContainer {
      width: 100%;
      background-color: #fff;

      ::v-deep(.van-tabs__wrap) {
        width: 400px;
        height: 105px;
      }

      ::v-deep(.van-tab) {
        font-size: 29px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
      }

      ::v-deep(.van-tab--active) {
        font-size: 36px;
        font-family: PingFang-SC-Heavy, PingFang-SC;
        font-weight: 800;
        color: #282b32;
      }

      ::v-deep(.van-tabs__line) {
        border-radius: 0 !important;
      }
    }

    .awaitAllotContainer {
      // width: 680px;
      padding: 0 29px;
      height: calc(100vh - 110px);
      background-color: #f7f9fa;
      overflow-y: auto;

      .awaitAllot {
        background-color: #fff;
        margin-top: 20px;
        border-radius: 9px;
        padding: 0 26px;

        .awaitAllotTitle {
          display: flex;
          align-items: center;
          padding-top: 5px;
          position: relative;

          ::v-deep(.van-checkbox__icon .van-icon) {
            width: 30px;
            height: 30px;
          }

          ::v-deep .van-icon-success:before {
            height: 30px;
          }

          .awaitAllotDriver {
            font-size: 36px;
            font-family: PingFang-SC-Bold, PingFang-SC;
            font-weight: bold;
            color: #282b32;
            // margin: 0 20px;
            margin-right: 20px;
            padding-top: 36px;

            img {
              width: 44px;
              height: 36px;
              margin-right: 16px;
            }
          }

          .tabBtn {
            // width: 106px;
            height: 40px;
            line-height: 40px;
            text-align: center;

            border-radius: 6px;
            padding: 0 10px;
            margin-top: 36px;
            // opacity: 0.1;
            font-size: 22px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
          }

          .btnColorGreen {
            background-color: #edf5f2;
            color: #4ea27c;
          }

          .btnColorBule {
            background-color: #eaf1fc;
            color: #2c76e3;
          }

          .checkbox {
            position: absolute;
            right: 0;
            top: 20px;
          }
        }

        .userInfo {
          margin-top: 25px;
          font-size: 26px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #282b32;

          .info {
            padding-bottom: 20px;
          }
        }
      }
    }
  }
}
</style>
